export default Object.freeze({
  // Default options:
  schoolDidNotProvide30MinBreak: 'schoolDidNotProvide30MinBreak',
  waivedMealBreak: 'waivedMealBreak',

  // Shared options:
  other: 'other',

  // Extended options:
  scheduleDidNotAllow: 'scheduleDidNotAllow',
  noTimelyMealBreak: 'noTimelyMealBreak',
  noMealBreak: 'noMealBreak',
  mealBreakInterrupted: 'mealBreakInterrupted',
  notRelievedOfDuties: 'notRelievedOfDuties',
  sixOrFewHourVoluntarilyWaivedMealBreak:
    'sixOrFewHourVoluntarilyWaivedMealBreak',
  voluntarilyNoMealBreak: 'voluntarilyNoMealBreak',
})
